export default {
  fa1867274c620cab693b19300a45ddaa: '商品信息曝光',
  '3e89518163a3351ffe9c3b45eb79c1e7': '購買了此商品',
  '05ab0a36affc1175c16fab9076748722': '商品詳情頁_SKU選擇抽屜',
  '4996955f4fc9a910a791be31c7a0472a': '商品詳情頁_SKU選擇抽屜_確定按鈕',
  '92de5d8d5ec05a369b92feb778ac1ad6': '商品詳情頁_SKU選擇抽屜_選擇訂閲模式',
  '9534aec7cb47306b9d4b998bb93552a0': '營銷商城',
  '1f6b456ffcd1373bf6051e0294229dc4': '該商品暫時無法購買，請聯繫客服',
  '952b517752a3d54632a5640bd983e3db': '領券失敗，請稍後再試',
  '94cf66d520636599442ae580f655732e': '原價',
  a3e40f84213811f2a5420230554d3dc5: '已下架',
  c966a45e7226d9eee149a7d5f542be9f: '登錄查看優惠',
  '29a0c08714a4c60d760cd5bf677ebc57': '暫無預約資格',
  fc4cb54ebbbc715d113476129bb4c0b8: '預約未開始',
  df87923079d7c0beb2c4559579a85862: '將於',
  ab9e4d1819317951394a1316fcf79a76: '開始預約',
  '88d0e2a03b050f0e0a8b13fec60ffe78': '開售',
  '3b0d4aa3dda61c76b8217fb7b8a78966': '即將開售',
  f1a8ca0bf5adda5ba15f7ddad58c2346: '預約成功',
  '1d2d66fef8bf1d9bc256e789a97c566d': '預約失敗',
  '0ec92c3187b7485cf5ec346e5c1ccd75': '立即預約',
  '1f3807f10bd3a5cd55a044733c9c0996': '已有',
  '261622ea4a29c8f12e789b844fc405b1': '人預約成功',
  '416fefbd19825f08b791241e7edd6a51': '商品詳情頁_預約活動',
  '3fb081aab838be9abd808e7a19a45c56': '立即購買',
  '162396af34628a10c00e1b1644110716': '商品為限購商品，您不滿足限購條件，無法購買',
  '669641b519d1f9bf11ded3320a76f079': '僅剩',
  c64a99d7afe2453355628b9b0dff433e: '天',
  '4c848c2101c0737bf8f0fb1e54e04130': '已搶完',
  e1e95652c564a2883bff1f99121934d8: '未開始',
  '86e47c5015f810ab093752bccbc4b791': '已結束',
  e812cd2beffffe788e963984841d39d0: '已搶光',
  f1e03e04de7143d17e58d507dcc16e1a: '已搶',
  '0283ca891df8ff2d91fad9917d24c699': '剩餘',
  '992f734b9ab6402aabe9863b1cf9d58d': '商品詳情頁_購買按鈕',
  '9a4d0400ff2d75d257318a86200a884a': '立即搶購',
  '26a625c871b5730a5028ee65d0ebbd18': '暫無資格前往獲取',
  '24b7cd62ef456f2c6f81908615a85c1c': '暫無兑換資格',
  e52ccbf0173ff6095d2b955c58bb6b85: '已售罄',
  df10c47ea53f3644cb9b3995c8def019: '單獨購買',
  '2abe7f76b1ef67ef9d1a3bbe2afe0a1f': '發起團購',
  ce545df1de3e9f821aa842fb8f580ce8: '成長豆不足立即獲取',
  '508db4afefb61cd38af412b31874d4ea': '成長豆餘額不足',
  b75075febe9e4b01de53c0e39e243cc4: '購物車按鈕',
  '1a47a6da484d3058d0974301171a0370': '商品詳情頁',
  ffaf8d4f12b89ab2c9866ccf84583b14: '購物車',
  c79163cb21cc27322b50bb6e22090275: '加入購物車',
  '168d94052e4771724dca6bf540390822': '選擇商品',
  '47688c2ad210c848d5368bc8917935af': '限時搶購',
  '4add70c59aaa6fff4f563d7b0abb9806': '免費領取',
  '118083967c1501a3ba4ed8f90f48f579': '立即兑換',
  '66c4341dd5a6ce1ac4abb0346c078042': '距開售僅剩',
  '9e178372463647f75cea572b82ec5034': '{day}天 {hour}:{minute}:{second}',
  ef8e7256d8e3cc00087df4b450c4c0b4: 'MM月DD日HH:mm',
  e9695eac45fefc77f14677ddc3639210: '結束',
  bbb9cf1247041e89c64d0b04b0264cc5: '加入購物車成功',
  '895f1ed7be4a2dff52b3ec47edc3de8a': '加入購物車失敗',
  '1c32ef03d1544e96db89fedc7afa1114': '已減',
  e64983c2cf4b6d4461e4c404bdc066be: '請選擇商品',
  '4b408e8c9aff77497db39c805e591284': '領券購買',
  '4e1c895fd1d75219af8bf261ac3fbf02': '確定',
  ac0b38c4e4a83be646db377c09d38e76: '參數錯誤!',
  '281cc99bc680ecf1a58bed226a39951b': '點擊播放視頻',
  '223b5a41656ee568204b0c862266a5c3': '分享',
  d045167754a45367b1884ad0acfbbd90: '配送',
  a855b1dba6164b6c42d62bec1e575cb5: '快遞配送',
  '91e48cde1965d26b4388fad2e07ffd3e': '説明',
  '6f576b416c5f5471bedae323ba304c71': '商品詳情頁_客服按鈕',
  fb5bbf467b0d4d15adf84492055bbba7: '客服',
  c1fea370ae50c6fbc27e520df63e0dd2: '適用於',
  c1a324ab0a445f9b5fcfe71c9eec0133: '商品詳情頁_SKU選擇抽屜_選擇商品',
  '0fc3286efd4cafb5a59ed10930a07a6b': '購買數量',
  ec1639bb0872bc4e2b7da0c93c1974e6: '前往查看',
  '887c3e401e47568d2322008ccac1dd58': '您已參加拼團活動,點擊下方按鈕查看拼團進度哦',
  a3eceb8e20af5c8a867d2ca0380f3458: '商品詳情頁_挽留 彈窗曝光',
  '6b908a8532c15fb1d35be87e33894c87': '商城',
  d317e2c21b292b6d885ad97e0279592d: '商品詳情頁_挽留彈窗內容按鈕點擊',
  '07f53e3f4a29c2469498c84d8084415f': '其他',
  bd48cd45b8b0cf763d9d1e752459921b: '商品詳情頁_挽留彈窗底部按鈕點擊'
};
